import { render, staticRenderFns } from "./adv_bank.vue?vue&type=template&id=47a07ca0&viewBox=0%200%2045%2045"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports